import { Heading, Modal, ModalBody, VFlow } from 'bold-ui'
import { TipoRegulacaoEnum } from 'graphql/types.generated'
import React from 'react'
import { humanizeAge } from 'util/date/humanize-age'

import { ListaRegulacamTableItem } from '../model-regulacao'
import { HistoricoRegulacaoEvolucao } from './components/HistoricoRegulacaoEvolucao'
import { RegulacaoModalItem } from './components/RegulacaoModalItem'

interface ListaRegulacaModalProps {
  item: ListaRegulacamTableItem
  handleClose(): void
}

export const ListaRegulacaoModal = (props: ListaRegulacaModalProps) => {
  const { item, handleClose } = props

  const cidadao = item.prontuario.cidadao
  const equipe = cidadao.cidadaoVinculacaoEquipe?.equipe?.nome ?? 'Sem equipe'
  const ubs = cidadao.cidadaoVinculacaoEquipe?.unidadeSaude?.nome
  const subtitle = [cidadao.nome, humanizeAge(cidadao.dataNascimento), equipe, ubs].join(' | ')

  return (
    <Modal open={true} onClose={handleClose} size='large' closeOnBackdropClick={false} style={{ width: '55rem' }}>
      <ModalBody style={{ padding: '2rem' }}>
        <VFlow vSpacing={0}>
          <Heading level={1}>{titleByTipoRegulacaoEnumMap[item.tipoRegulacao]}</Heading>
          <Heading level={5} fontWeight='normal'>
            {subtitle}
          </Heading>
        </VFlow>
        <HistoricoRegulacaoEvolucao id={item.id} />
        <RegulacaoModalItem item={item} />
      </ModalBody>
    </Modal>
  )
}

const titleByTipoRegulacaoEnumMap: Record<TipoRegulacaoEnum, string> = {
  GUIA_ENCAMINHAMENTO: 'Solicitação de guia de encaminhamento',
  SOLICITACAO_EXAME_COMUM: 'Solicitação de exame comum',
  SOLICITACAO_EXAME_ALTO_CUSTO: 'Solicitação de exame de alto custo',
  SOLICITACAO_EXAME_OCI: 'Solicitação de OCI',
}
